import NgrxAuth from '../../auth/Auth'
import {
  ACTIVATE_QUESTIONS_LOADING,
  ACTIVATE_QUESTIONS_SUCCESS,
  ACTIVATE_QUESTIONS_FAILED,

  ACTIVATE_SEND_LOADING,
  ACTIVATE_SEND_SUCCESS,
  ACTIVATE_SEND_FAILED,

  ACTIVATION_LOADING,
  ACTIVATION_SUCCESS,
  ACTIVATION_FAILED,

  HANDLE_NEXT,
  HANDLE_PREV,
  CLOSE_SNACK,
  RESET_INDEX,
  PULL_INDEX
} from '../actions/activateActions.js'

const Activate = (state = {
  isFetching: false,
  error: null,
  questions: [],
  stepIndex: 0,
  dataSent: {},
  openSnackBar: false
}, action) => {
  switch (action.type) {
    case ACTIVATE_QUESTIONS_LOADING:
      return Object.assign({}, state, {
        isFetching: true,
        dataSent: action.dataSent
      })
    case ACTIVATE_QUESTIONS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        questions: action.response
      })
    case ACTIVATE_QUESTIONS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error
      })
    case ACTIVATE_SEND_LOADING:
      return Object.assign({}, state, {
        isFetching: true
      })
    case ACTIVATE_SEND_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        error: null
      })
    case ACTIVATE_SEND_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error
      })
    case HANDLE_NEXT:
      return Object.assign({}, state, {
        stepIndex: state.stepIndex + 1
      })
    case HANDLE_PREV:
      return Object.assign({}, state, {
        stepIndex: state.stepIndex - 1
      })
    case ACTIVATION_LOADING:
      return Object.assign({}, state, {
        isFetching: true
      })
    case ACTIVATION_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
        openSnackBar: true
      })
    case ACTIVATION_SUCCESS:
      NgrxAuth.accessToken = action.response.access_token
      window.localStorage.removeItem('username')
      window.localStorage.removeItem('stepIndex')
      return Object.assign({}, state, {
        isFetching: false,
        error: null
      })
    case CLOSE_SNACK:
      return Object.assign({}, state, {
        openSnackBar: false
      })
    case RESET_INDEX:
      return Object.assign({}, state, {
        stepIndex: 0
      })
    case PULL_INDEX:
      return Object.assign({}, state, {
        stepIndex: Number(window.localStorage.getItem('stepIndex'))
      })
    default:
      return state
  }
}

export default Activate



// WEBPACK FOOTER //
// ./src/redux/reducers/activateReducer.js